const COOKIE_ENUMS = {
  SELECTED_STORE_LOCALE: 'selected_store_locale',
};

export default COOKIE_ENUMS;
